export default {
  brand: 'Laplace x GTM',
  login: 'Log in',
  getStarted: 'Get started',

  heroKicker: 'AI SDR for B2B sales',
  heroHeadline: 'Find the right buyers. <accent>Know what to say.</accent>',
  heroSubtitle:
    'Enter your website and see <strong>real buyers with first emails</strong> in two minutes.',
  urlLabel: 'Your company website',
  urlPlaceholder: 'yourcompany.com',
  submit: 'Find my leads',
  submitting: 'Starting…',
  submitHint: 'Free preview. No signup or card.',

  progressTitle: 'Your GTM employee is on it',
  progressHint: 'This usually takes 20–40 seconds.',
  step_research_company: 'Researching your company',
  step_finding_leads: 'Finding decision makers',
  step_writing_emails: 'Writing personal emails',

  profileTitle: 'What we learned about {{company}}',
  icpTitle: 'Who buys from you',
  icpIndustries: 'Industries',
  icpJobTitles: 'Decision makers',
  icpCompanySizes: 'Company size',
  icpLocations: 'Locations',
  icpPainPoints: 'Problems you solve',
  employees: '{{size}} employees',
  researchCoverage: 'Read {{count}} pages on {{domain}}',
  researchSitemap: 'the site map lists {{pages}}',
  researchLlmsTxt: 'including llms.txt',
  peopleTitle: 'Founders and leadership',
  personSource: 'source',
  keyFeatures: 'Key features',
  namedCustomers: 'Customers they name',
  socialProfiles: 'Official profiles',

  leadsTitle: '{{count}} leads match your ideal customer',
  leadsHint:
    'Contact details and the full list unlock when you start a campaign.',
  leadHasLinkedin: 'LinkedIn',
  leadHasVerifiedEmail: 'Verified email',
  nextTitle: 'From plan to pipeline',
  next_send: 'Reach out to prospects',
  next_meetings: 'Turn replies into meetings',
  next_learn: 'Refine your next campaign',
  outreachStart: 'Start outreach',
  outreachSend: 'Start outreach & send',
  outreachTo: 'To',
  outreachSubject: 'Subj',
  outreachBody: 'Email draft',
  outreachLinkedin: "{{name}}'s LinkedIn profile",
  outreachFromSite: 'from the company site',
  outreachSourcesChecked_one: 'checked across {{count}} source',
  outreachSourcesChecked_other: 'checked across {{count}} sources',
  outreachNoneFound: 'No work emails were found for these people yet.',
  sampleDraftNoRecipient: 'No real recipient — sample only',
  checkoutPreparing: 'Preparing checkout…',
  outreachRecipients: 'People with draft emails',
  outreachContinue: 'Send',
  emailStatus_valid: 'Verified',
  emailStatus_catch_all: 'Delivery uncertain',
  emailStatus_unknown: 'Unverified',
  emailStatus_invalid: 'Undeliverable',
  emailStatusHint_valid: 'This email address passed verification.',
  emailStatusHint_catch_all:
    'This domain accepts all addresses, so delivery cannot be confirmed.',
  emailStatusHint_unknown: 'This email address has not been verified.',
  emailStatusHint_invalid:
    'This address cannot receive email and will not be written to.',
  emailHiddenUntilCampaign: 'The address opens once the campaign starts.',
  leadLocked: 'Unlocks after start',
  leadWithEmail: 'Email drafted',
  sampleData:
    'Sample data: the contact provider is not connected yet, these people are illustrative.',

  emailsTitle: 'Emails ready to send',
  emailTo: 'To {{name}}, {{title}} at {{company}}',
  emailSubject: 'Subject',

  estimateTitle: 'What ${{budget}} gets you',
  estimateReplies: 'Positive replies',
  estimateMeetings: 'Meetings',
  estimateNote: 'Estimate from B2B email industry benchmarks, not a guarantee.',

  checkoutBalanceLabel: 'Amount',
  checkoutAmountLabel: 'Amount, USD',
  checkoutPayTitle: 'Top up balance',
  checkoutAuthTitle: 'Account',
  checkoutAuthText: 'Sign up or log in to continue.',
  checkoutAuthContinue: 'Continue',
  startTitle: 'Setting up your GTM workspace',
  startText: 'Moving your analysis, campaigns, leads and drafts.',
  startErrorTitle: 'The workspace is not ready yet',
  startErrorText: 'Your demo is saved. Try again in a moment.',
  startRetry: 'Try again',
  startOpenApp: 'Open Laplace',
  checkoutSignedInText: 'Signed in. The balance is added to this account.',
  checkoutAccountTitle: 'Account',
  checkoutPayText: 'Choose an amount and continue.',
  checkoutCardNumber: 'Card number',
  checkoutCardExpiry: 'Expiration date',
  checkoutCardCvc: 'CVC',
  checkoutCardNumberError: 'Enter the card number shown in the field.',
  checkoutCardExpiryError: 'Enter the date shown in the field.',
  checkoutCardCvcError: 'Enter the CVC shown in the field.',
  checkoutAgreement:
    'By paying, you agree to the <terms>Terms of Service</terms> and the <refund>Refund Policy</refund>: credits are refundable only before your first email is sent.',
  checkoutConfirm: 'Confirm & continue',
  checkoutError: 'Something went wrong. Please try again.',
  checkoutDoneTitle: 'Balance topped up',
  checkoutDoneText: '${{amount}} was added to your balance.',
  checkoutDoneWorkspace: 'Your GTM workspace is ready.',
  checkoutOpenWorkspace: 'Open GTM workspace',
  checkoutClose: 'Done',
  ctaTitle: 'Start the campaign',
  ctaHowItWorks: 'How your campaign works',
  ctaText:
    'Buy credits from $50, and your campaigns, leads and drafts move into your workspace. Emails go out from pre-warmed mailboxes assigned to your account, and nothing is sent until you press Send.',
  ctaButton: 'Start campaign',
  tryAnother: 'Try another website',

  error_invalid_url:
    'That doesn’t look like a website address. Try something like yourcompany.com.',
  error_site_unreachable:
    'We couldn’t open that website. Check the address and try again.',
  error_site_blocked:
    'That address can’t be analysed. Use your public company website.',
  error_site_empty:
    'There isn’t enough text on that page to understand your business. Try your main marketing site.',
  error_no_leads: 'No matching people found. Try another segment or campaign.',
  error_leads_unavailable:
    'We couldn’t find people for these campaigns. Try again.',
  error_generation_failed:
    'Something went wrong while analysing the site. Please try again.',
  error_capacity_reached:
    'We’ve reached today’s limit for free analyses. Come back tomorrow or sign up to get started.',
  error_rate_limited:
    'Too many attempts. Please wait a few minutes and try again.',
  error_unavailable: 'The instant demo isn’t available right now.',
  error_expired: 'This result is no longer available. Run a new analysis.',
  error_internal: 'Something went wrong. Please try again.',

  runTitle: 'Building your GTM plan for {{domain}}',
  runSubtitle:
    'Your GTM employee works through six steps. Results appear as each one finishes.',
  runLoading: 'Loading your run…',
  runBack: 'Try another website',
  runWorkspace: 'GTM workspace',
  runStagesNav: 'Research stages',
  runResearchTrail: 'Research trail',
  runTrailHint: 'What your GTM employee has learned so far.',
  runProgress: '{{done}} of {{total}} stages complete',
  runProgressLabel: 'Research progress',
  stage_research: 'Research your company',
  stage_competitors: 'Explore competitors',
  stage_campaigns: 'Define campaigns',
  stage_companies: 'Find potential customers',
  stage_decision_makers: 'Find decision makers',
  stage_emails: 'Write emails',
  ws_stageDescription_research: 'Company, offer and ideal customer profile',
  ws_stageDescription_competitors: 'Market alternatives and positioning',
  ws_stageDescription_campaigns: 'Buyer teams, angles and priorities',
  ws_stageDescription_companies: 'Accounts matching the selected campaigns',
  ws_stageDescription_decision_makers: 'Relevant people inside target accounts',
  ws_stageDescription_emails: 'Prepared outreach for verified recipients',
  stageStatus_pending: 'Waiting',
  stageStatus_active: 'In progress…',
  stageStatus_done: 'Done',
  stageStatus_missing_contacts: 'Research complete — no verified contacts',
  stageStatus_failed: 'Stopped',
  stageSample: 'Sample',
  campaignPrimary: 'Primary',
  campaignShareTitle: 'Suggested share of the outreach budget',
  campaignsNone: 'Could not define campaigns for this company.',
  buyerTitle: 'Who buys',
  buyerProductType_team_tool: 'Team tool',
  buyerProductType_company_wide: 'Company-wide product',
  buyerProductTypeHint_team_tool:
    "Solves one team's pain; that team's leader buys it.",
  buyerProductTypeHint_company_wide:
    'Compliance, security, company finance or strategy; a C-level buys it.',
  buyerSize: '{{size}} employees',
  buyerExcluded: 'Never write to',
  buyerManual: 'Set by you',
  buyerManualHint: 'You changed this; automatic updates keep it.',
  buyerEdit: 'Change',
  buyerDialogTitle: 'Who buys in a company',
  buyerDialogText:
    'Pick whom to write to in a company of each size, primary first. What you set here is kept.',
  buyerProductTypeLabel: 'Product type',
  buyerSave: 'Save',
  buyerCancel: 'Cancel',
  buyerSaveError: 'Could not save. Try again.',
  buyerNoRoles: 'nobody',
  buyerRole_founder: 'Founder',
  buyerRole_vp: 'VP of {{area}}',
  buyerRole_director: 'Director of {{area}}',
  buyerRole_head: 'Head of {{area}}',
  buyerRole_lead: '{{area}} lead',
  buyerCLevel_leadership: 'CEO',
  buyerCLevel_sales: 'CRO',
  buyerCLevel_marketing: 'CMO',
  buyerCLevel_engineering: 'CTO',
  buyerCLevel_ai_data: 'Chief Data Officer',
  buyerCLevel_product: 'CPO',
  buyerCLevel_operations: 'COO',
  buyerCLevel_finance: 'CFO',
  buyerCLevel_people: 'CHRO',
  buyerCLevel_it_security: 'CISO',
  buyerCLevel_customer_support: 'Chief Customer Officer',
  buyerArea_leadership: 'Leadership',
  buyerArea_sales: 'Sales',
  buyerArea_marketing: 'Marketing',
  buyerArea_customer_support: 'Support',
  buyerArea_engineering: 'Engineering',
  buyerArea_ai_data: 'Data',
  buyerArea_product: 'Product',
  buyerArea_operations: 'Operations',
  buyerArea_finance: 'Finance',
  buyerArea_people: 'People',
  buyerArea_it_security: 'Security',
  buyerArea_other: 'Operations',
  buyerFitSize: 'a company of {{size}} people',
  buyerFitSizeEstimate: 'a company of about {{size}} people (estimated)',
  buyerFitSizeUnknown: 'company size unknown, taken as 51–200',
  buyerFitTeamTool: 'a product for the {{area}} team',
  buyerFitCompanyWide: 'a company-wide product',
  buyerFitFallback: 'No {{target}} found, next on the ladder',
  campaignWho: 'Who',
  campaignEmployees: '{{sizes}} employees',
  campaignTrigger_hiring: 'Hiring',
  campaignTrigger_funding: 'Funding',
  campaignTrigger_expansion: 'Expansion',
  campaignTrigger_leadership_change: 'New leader',
  campaignTrigger_uses_competitor: 'Uses a competitor',
  campaignVs: 'vs {{name}}:',
  campaignProof: 'Proof',
  companiesNone: 'No companies found for these campaigns.',
  companyEmployees_one: '{{count}} employee',
  companyEmployees_other: '{{count}} employees',
  companyUsesCompetitor: 'Uses {{name}}',

  stepLog: 'step {{n}}',
  stepOf: 'Step {{n}} of {{total}}',
  researchFound: 'Found',
  researchWorking: 'Researching…',
  researchLookingFor: 'Looking for',
  stageWorking: 'Working on this step…',
  stageWaiting: 'This step starts after the previous one.',
  showMore: 'More',
  showLess: 'Less',
  keywordsLabel: 'Keywords',
  productLabel: 'Product',
  queriesLabel: 'Queries',
  competitorsLabel: 'Competitors',
  competitorsInRegion: 'Competitors in {{regions}}',
  competitorsInRegionNone: 'No competitors found that sell there.',
  competitorsOther: 'Other competitors',
  salesRegionsTitle: 'Sells in',
  competitorsNone: 'No competitors found on the web for this company.',
  competitorVia: 'via {{host}}',
  competitorsMore_one: 'and {{count}} more',
  competitorsMore_other: 'and {{count}} more',
  previewTitle: 'What you get in two minutes',
  previewSubtitle:
    'Your site goes through the same steps a sales team would take, and you see the result of each one.',
  preview_research: 'We read your site: your offer, who buys it and why',
  preview_competitors: 'Who you compete with, and whose customers you can win',
  preview_campaigns: 'Who to sell to first, ranked by budget share',
  preview_companies: 'Real companies that fit each campaign',
  preview_decision_makers:
    'The people who decide, with LinkedIn and a verified email',
  previewSubject: 'quoting in minutes, not days',

  flowTitle: 'What happens after you start',
  flowText:
    'Your campaigns, leads and first emails move into your workspace. You read each draft and press Send. Emails go out from pre-warmed mailboxes assigned to your account, never from your own domain, at up to 25 a day per mailbox. Replies land in your inbox, sorted, with an answer drafted for you.',
  flowPointMailbox: 'Pre-warmed mailboxes, never your domain',
  flowPointFollowUp: 'Follow-ups come due on schedule',
  flowPointReplies: 'Replies sorted, answers drafted for you',
  flowMon: 'Mon',
  flowThu: 'Thu',
  flowFri: 'Fri',
  flowFirstBody:
    'Hi Maya, your reps quote freight by hand from three systems, which is where deals stall at your size.',
  flowFollowUpBody:
    'Hi Maya, following up on my note. Worth a 15-minute call next week?',
  flowReply: 'Interesting. Does it work with our TMS, and how long is setup?',
  flowSending: 'Sending…',
  flowIncoming: 'New reply…',
  flowDrafting: 'Drafting a reply…',
  flowDraftBody:
    'Hi Maya, yes, it works with most TMS platforms, and setup takes about a week. Does Tuesday at 10:30 work for a short call?',

  indexTitle: 'Our <accent>own database</accent> of B2B buyers',
  indexText:
    'Every run adds companies, decision makers and verified addresses to our own index. Your search starts there, so leads come back faster, and we re-read a company when its website changes.',
  indexPoint1: 'Searched first, before any outside source.',
  indexPoint2: 'Every address is verified before it is used.',
  indexPoint3:
    'Lead search and research are included: you pay only for emails sent.',

  trustTitle: 'Where the data comes from, and how we send',
  trust1Title: 'Public sources only',
  trust1Text:
    'Companies and people come from public sources and trusted data providers. Every address is verified before a single email goes out.',
  trust2Title: 'Verified before sending',
  trust2Text:
    'Each address is checked with email verification services. Anything unverified is checked again before a single email goes out.',
  trust3Title: 'Dedicated sending mailboxes',
  trust3Text:
    'Emails go out from authenticated mailboxes assigned to your account, never from your own domain, at a safe daily pace. Replies come back to your Laplace inbox.',
  trust4Title: 'Opt-outs are honoured',
  trust4Text:
    'A reply asking not to be emailed is recognised automatically, and that person is never contacted again.',

  testimonialsTitle: 'What customers are saying',

  pricingTitle: 'Pay as you go, no subscription',
  pricingTopUp: 'Your top-up',
  pricingPerEmail: 'Per email sent',
  pricingPerEmailValue: '${{value}}',
  pricingEmails: 'Emails for ${{budget}}',
  pricingPeople: 'People reached, 2–3 emails each',

  finalTitle: 'See who could buy from you',
  finalButton: 'Analyse my website',
  ws_navOverview: 'Overview',
  ws_navCampaigns: 'Campaigns',
  ws_navLeads: 'Leads',
  ws_stage_found: 'Found',
  ws_stage_queued: 'Queued',
  ws_stage_contacted: 'Emailed',
  ws_stageContactedStep: 'Email {{step}} sent',
  ws_stage_interested: 'Interested',
  ws_stage_objection: 'Objection',
  ws_reserve: 'Reserve',
  ws_reserveRank: 'Reserve #{{rank}}',
  ws_reserveState_waiting: 'waiting',
  ws_reserveState_busy: 'held by another client',
  ws_reserveState_unreachable: 'no address',
  ws_reserveState_stopped: 'stopped',
  ws_stage_no_reply: 'No reply',
  ws_stage_not_now: 'Not now',
  ws_stage_out_of_office: 'Out of office',
  ws_stage_meeting_booked: 'Meeting booked',
  ws_stage_meeting_held: 'Meeting held',
  ws_stage_won: 'Won',
  ws_stage_lost: 'Lost',
  ws_stage_not_interested: 'Not interested',
  ws_stage_bounced: 'Bounced',
  ws_stage_unsubscribed: 'Unsubscribed',
  ws_next_send_email: 'Send the next email',
  ws_next_reply: 'Reply',
  ws_next_resume: 'Resume the sequence',
  ws_next_follow_up: 'Follow up',
  ws_next_attend_meeting: 'Meeting',
  ws_next_recontact: 'May be contacted again',
  ws_next_none: 'Nothing planned',
  ws_noEmail: 'No address yet',
  ws_loadingLead: 'Loading lead',
  ws_loadingLeadDescription: 'Loading lead details and email history.',
  ws_markTitle: 'Mark what happened',
  ws_markSent: 'Email {{step}} sent',
  ws_notePlaceholder: 'Note for the history (optional)',
  ws_nextDate: 'Next date (optional)',
  ws_updateError: 'Could not save. Try again.',
  ws_emailsTitle: 'Emails',
  ws_emailStep: 'Email {{step}}',
  ws_message_draft: 'draft',
  ws_message_queued: 'ready to send',
  ws_message_sent: 'sent',
  ws_message_sending: 'sending',
  ws_message_send_unknown: 'checking delivery',
  ws_message_failed: 'failed',
  ws_removed_person_busy:
    "This person is already being contacted by another company. We'll pick someone else instead.",
  ws_removed_email_invalid:
    "This address no longer receives email. We'll pick someone else instead.",
  ws_removed_email_unverifiable:
    "This address could not be confirmed. We'll pick someone else instead.",
  ws_removed_company_busy:
    "Someone else at this company is already being contacted. This person stays in the company's reserve.",
  ws_emailMaskedHint:
    'The full address opens after the first email to this person is sent.',
  ws_addressesPaused_no_balance:
    'New people were found, but their addresses and emails were not prepared: the balance is empty. They will appear after a top-up.',
  ws_addressesPaused_no_capacity:
    'New people were found, but their addresses and emails were not prepared: the mailboxes have no free room in the next days. They will appear as room frees up.',
  ws_searchRefused_free_search_limit: 'Top up the balance to keep searching.',
  ws_dailyLimitReached:
    'Email capacity for the last 24 hours is used up. Your drafts are saved.',
  ws_senderLimitReached:
    'This conversation’s mailbox reached its 24-hour limit. Try again later; the draft is saved.',
  ws_sidebarUsageTitle: 'Usage',
  ws_usageCapacity: 'Email limit',
  ws_usageBalance: 'Balance',
  ws_usageNotAvailable: 'Not available yet',
  ws_usageLoadFailed: 'Couldn’t load usage',
  ws_usageCapacityValue: '{{remaining}} of {{total}} left in the last 24 hours',
  ws_usageCapacityUsed: 'Emails sent in the last 24 hours',
  ws_usageNextLimit: 'The limit grows to {{limit}} emails a day by {{date}}',
  ws_insufficientBalance: 'Not enough balance to send one email.',
  ws_send: 'Send email',
  ws_retrySend: 'Retry send',
  ws_sendError: 'The email was not sent. Try again.',
  ws_draftSaved: 'Reply draft saved below. Review it, then press Send.',
  ws_composerFrom: 'From',
  ws_discardChanges: 'Discard changes',
  ws_unsavedChanges: 'Unsaved changes',
  ws_sendReply: 'Send',
  ws_refreshInbox: 'Refresh',
  ws_inboxNoNewReplies: 'No new replies',
  ws_inboxNewReplies_one: '{{count}} new reply',
  ws_inboxNewReplies_other: '{{count}} new replies',
  ws_inboxRefreshFailed:
    'Couldn’t check for new replies. Try again in a moment.',
  ws_replyComposer: 'Reply',
  ws_aiDraftTitle: 'AI response draft',
  ws_reviewBeforeSend:
    'Review before sending. Drafts are never sent automatically.',
  ws_saveDraft: 'Save draft',
  ws_manualReply: 'Paste a reply manually',
  ws_moreActions: 'Lead actions and history',
  ws_historyTitle: 'History',
  ws_leadsQueue: 'Outreach queue',
  ws_leadsQueueEmpty:
    'No verified contacts are waiting for a first email. Sent conversations are in Inbox.',
  ws_firstEmailChecking: 'Checking whether the email was delivered.',
  ws_backToLeads: 'Back to leads',
  ws_subject: 'Subject',
  ws_you: 'You',
  ws_leadsTitle: 'Leads',
  ws_outreach_start: 'Start outreach',
  ws_outreach_pause: 'Pause',
  ws_outreach_resume: 'Resume',
  ws_outreachToday_one:
    'Today {{count}} email: {{followUps}} follow-ups and {{fresh}} new.',
  ws_outreachToday_other:
    'Today {{count}} emails: {{followUps}} follow-ups and {{fresh}} new.',
  ws_outreachQueueDays_one: 'Queue for {{count}} day.',
  ws_outreachQueueDays_other: 'Queue for {{count}} days.',
  ws_outreachReview_one:
    'Review mode: {{count}} email ready to send — send it by hand.',
  ws_outreachReview_other:
    'Review mode: {{count}} emails ready to send — send them by hand.',
  ws_outreachPaused_no_balance:
    'Nothing goes out: the balance is used up. Top up to continue.',
  ws_outreachPaused_no_mailbox:
    'Nothing goes out: no mailbox can send right now.',
  ws_outreachRefused_no_mailbox:
    'No mailbox can send right now. Try again later.',
  ws_outreachError: 'Outreach could not be changed. Try again.',
  ws_colCompany: 'Company',
  ws_colCampaign: 'Campaign',
  ws_colEmail: 'Email',
  ws_colStage: 'Stage',
  ws_colNext: 'Next',
  ws_campaignsTitle: 'Campaigns',
  ws_campaignsText:
    'One campaign per buyer team. The budget share shows where GTM spends first.',
  ws_colShare: 'Budget share',
  ws_colLeads: 'Leads',
  ws_colContacted: 'Emailed',
  ws_colReplies: 'Replies',
  ws_colMeetings: 'Meetings',
  ws_tileQueued: 'Ready to send',
  ws_tileContacted: 'Emailed',
  ws_tileReplied: 'Replied',
  ws_tileMeetings: 'Meetings',
  ws_dueTitle_one: '{{count}} lead needs action today',
  ws_dueTitle_other: '{{count}} leads need action today',
  ws_dueText:
    'Emails to send and replies to answer. Mark each one once it is done.',
  ws_dueAction: 'Open the queue',
  ws_campaignsCount_one: '{{count}} campaign is running.',
  ws_campaignsCount_other: '{{count}} campaigns are running.',
  ws_navInbox: 'Inbox',
  ws_navAnalysis: 'Analysis',
  ws_navConversations: 'Conversations',
  ws_navSettings: 'Settings',
  ws_inboxTitle: 'Inbox',
  ws_inboxEmailText: 'Sent emails and replies, newest first.',
  ws_inboxError: 'Inbox could not be loaded. Try again.',
  ws_inboxText: 'What GTM needs from you today for {{company}}.',
  ws_inboxEmpty:
    'Nothing due right now. New emails and replies will show up here.',
  ws_attentionTitle: 'Needs your attention',
  ws_campaignActivity: 'Campaign activity',
  ws_campaignSummary: '{{contacted}} emailed · {{replies}} replies',
  ws_group_reply: 'Replies to answer',
  ws_group_send: 'Emails to send',
  ws_group_resume: 'Threads to pick up',
  ws_group_meetings: 'Meetings',
  ws_sendStep: 'Email {{step}}',
  ws_open: 'Open',
  ws_searchRunning: 'Searching: {{step}}…',
  ws_searchFailed: 'The search did not finish. Try again.',
  ws_searchStep_research_company: 'reading your company',
  ws_searchStep_exploring_competitors: 'checking competitors',
  ws_searchStep_defining_campaigns: 'preparing campaigns',
  ws_searchStep_finding_companies: 'finding companies',
  ws_searchStep_finding_leads: 'finding decision makers',
  ws_searchStep_finding_emails: 'finding emails',
  ws_searchStep_writing_emails: 'writing emails',
  ws_searchStep_done: 'finishing',
  ws_replyTitle: 'Their reply',
  ws_replyPlaceholder:
    'Paste the reply here: GTM reads it, updates the stage and drafts an answer.',
  ws_replyRead: 'Read the reply',
  ws_replyReading: 'Reading…',
  ws_replyReadAs: 'GTM read it as',
  ws_replyNoAnswer: 'No answer needed. The stage and next date are updated.',
  ws_answerSubject: 'Answer subject',
  ws_answerBody: 'Answer text',
  ws_answerSent: 'Answer sent',
  ws_answerDiscard: 'Discard draft',
  ws_answerHint: 'Send it from your mailbox, then mark it here.',
  ws_threadTitle: 'Thread',
  ws_threadEmpty: 'No messages yet.',
  ws_ourAnswer: 'Our answer',
  ws_message_received: 'received',
  ws_conversationsTitle: 'Conversations',
  ws_conversationsText:
    'Review every thread, edit AI drafts, and decide what gets sent.',
  ws_conversationList: 'Conversation list',
  ws_selectConversation: 'Select a conversation to read the thread.',
  ws_noConversations: 'No email conversations yet.',
  ws_analysisTitle: 'Analysis',
  ws_analysisText: 'Company research and campaign strategy for this project.',
  ws_analysisEmpty: 'This project has no saved analysis yet.',
  ws_analysisError: 'The saved analysis could not be loaded. Try again.',
  ws_analysisStageEmpty: 'No saved result is available for this stage.',
  ws_emailUnknown: 'email status unknown',
  ws_needsReply: 'Needs reply',
  ws_draftsCount_one: '{{count}} draft',
  ws_draftsCount_other: '{{count}} drafts',
  ws_showQuotedHistory: 'Show quoted email history',
  ws_sampleNotSendable: 'Sample leads cannot receive real email.',
  ws_sendingUnavailable: 'Sending is temporarily unavailable',
  ws_dailyRemaining: '{{count}} available today',
  ws_settingsTitle: 'GTM Settings',
  ws_settingsTabGeneral: 'General',
  ws_settingsTabEmails: 'Emails',
  ws_settingsTabSending: 'Sending',
  ws_outreachPausedLine: 'Emails wait until you resume it.',
  ws_outreachStoppedLine_review:
    'Once it starts, emails are prepared every business day.',
  ws_outreachStoppedLine_autopilot:
    'Once it starts, emails go out on schedule.',
  ws_outreachStatus_paused: 'Outreach is paused.',
  ws_outreachStatus_running: 'Outreach is running.',
  ws_outreachStatus_stopped: 'Outreach is stopped.',
  ws_outreachToolbar: 'Outreach',
  ws_emailStepSummary_3: 'A short reminder; no more emails after it',
  ws_emailStepSummary_2: 'A new angle or an example, without repeating email 1',
  ws_emailStepSummary_1:
    'Who you are and why you write; ends with a question, no call',
  ws_sendingTo: 'To',
  ws_sendingFrom: 'From',
  ws_sendingWindow: 'Sending time',
  ws_sendingSettingsLoading: 'Loading sending settings…',
  ws_sendingSettingsError: 'Sending settings could not be loaded. Try again.',
  ws_sendingSchedule: 'Schedule',
  ws_sendingGap2: 'Email 2 after',
  ws_sendingGap3: 'Email 3 after',
  ws_sendingWorkingDays: 'Sending days',
  ws_sendingRecipientTime: 'in the recipient’s time',
  ws_settingsText: 'Company context, balance and the style of your emails.',
  ws_settingsLoading: 'Loading GTM settings…',
  ws_settingsError: 'GTM settings could not be loaded. Try again.',
  ws_companyContext: 'Company context',
  ws_analyzedCompany: 'Analyzed company',
  ws_analyzedDomain: 'Analyzed domain',
  ws_domainUnavailable: 'Not available',
  ws_creditDetails: 'Usage and credits',
  ws_emailSettingsLoading: 'Loading email settings…',
  ws_emailSettingsError: 'Email settings could not be loaded. Try again.',
  ws_emailStep_1: 'Email 1 · Intro',
  ws_emailStep_2: 'Email 2 · New angle',
  ws_emailStep_3: 'Email 3 · Follow-up',
  ws_sendingDefaultsFit: 'The defaults suit most teams.',
  ws_emailTone_soft: 'Soft',
  ws_emailTone_formal: 'Formal',
  ws_emailTone_conversational: 'Conversational',
  ws_emailsEditOnLeads:
    'You can change a single email in the lead’s draft on Leads.',
  ws_save: 'Save',
  ws_cancel: 'Cancel',
  ws_saved: 'Saved',
  ws_tryAgain: 'Couldn’t do that. Try again.',
  ws_emailPreviewLoading: 'Writing the email…',
  ws_emailPreviewExample: 'example',
  ws_sendingFewerDays: 'One day less',
  ws_sendingMoreDays: 'One day more',
  ws_sendingBusinessDays_one: 'business day',
  ws_sendingBusinessDays_other: 'business days',
  ws_emailTone: 'Tone',
  ws_draftIssue_meetingAsk:
    'Asks for a call in the first email: held until you edit or send it yourself.',
  ws_draftIssue_inventedNumbers:
    'Numbers not in your facts: {{numbers}}. Held until you check them.',
  ws_draftIssue_bannedPhrases: 'Template phrases to rewrite: {{phrases}}.',
  ws_projectsEmpty: 'No projects yet',
  ws_projectsError: 'GTM projects could not be loaded. Try again.',
  ws_projects: 'Projects',
  ws_campaignLabel: 'Campaign: {{name}}',
  ws_openCampaignStrategy: 'Open the campaign strategy in Analysis',
  ws_campaignProgress: 'Campaign progress',
  ws_project: 'Project',
  ws_projectSearch: 'Search projects',
  ws_newProject: 'New project',
  ws_newProjectDescription:
    'Enter a company website. Confirming starts the existing six-stage analysis and may consume configured provider usage.',
  ws_newProjectError:
    'The project could not be created. Check the website and try again.',
  ws_startProjectAnalysis: 'Start analysis',
  cancel: 'Cancel',
  ws_creditsPurchased: 'Credits purchased',
  ws_sendCost: 'Cost per successful send',
  ws_availableCredit: 'Available credit',
  ws_creditedCapacity: 'Credited send capacity',
  ws_hireButton: 'Hire an employee',
  ws_hireTitle: 'Hire a digital employee',
  ws_hireText:
    'An employee works inside this workspace and pays from your organization balance.',
  ws_hireGtmText:
    'Finds companies and decision makers, writes the emails, reads replies and books meetings.',
  ws_hireUrlLabel: 'Your company website',
  ws_hireGtm: 'Hire GTM',
  ws_hireHint:
    'About two minutes: GTM researches your site and finds the first leads.',
  ws_hireForbidden: 'Only workspace admins can hire employees.',
  ws_hireBadUrl: 'Check the website address and try again.',
  ws_soon: 'Soon',
  ws_employee_tender_scout: 'Tender Scout',
  ws_employee_tender_scout_text:
    'Finds tenders that fit your company and prepares the bid.',
  ws_employee_secure_by_design: 'Secure by Design',
  ws_employee_secure_by_design_text:
    'Checks your repositories, finds vulnerabilities and proposes fixes.',

  // Pay first, then sign up (LP-272).
  checkoutPay: 'Pay ${{amount}}',
  checkoutPayTest: 'Pay ${{amount}} (test payment)',
  checkoutPayNote:
    'Secure checkout by Paddle. You create your account right after paying.',
  checkoutTestNote: 'Test mode: no money is charged.',
  checkoutEmails: '≈ {{emails}} emails at ${{price}} each',
  checkoutConfirming: 'Confirming the payment…',
  checkoutConfirmingSlow:
    'The payment is still being confirmed. This page updates on its own.',
  checkoutCanceled: 'The payment was not completed. You can try again.',
  checkoutPaidTitle: 'Payment received',
  checkoutPaidText:
    '${{amount}} is waiting for your account. Create it to start.',
  checkoutContinueToWorkspace: 'Continue to the GTM workspace',
  checkoutCreateAccount: 'Create account',
  checkoutContinueToPayment: 'Continue to payment',
  checkoutChangeAmount: 'Change amount',
  checkoutSummaryItem: 'Laplace GTM credits',
  checkoutSummarySubtotal: 'Subtotal',
  checkoutSummaryTax: 'Tax',
  checkoutSummaryTotal: 'Total due today',
  checkoutSummaryTaxNote:
    'Tax for your country is added on top; Paddle shows it before you pay.',
  checkoutAccountRequired:
    'Complete your account details and accept the terms on the right to pay.',
  checkoutGuestText:
    'Fill it in once: the account is created as soon as the payment goes through. Paddle takes the payment with this email.',
  startPaymentPending: 'Waiting for the payment confirmation…',
  startProofTitle: 'Use the email you paid with',
  startProofText:
    'This purchase was paid with another email. Sign up with the email you paid with, or open this link in the browser you paid in.',
  startPaymentRequired: 'This checkout is not paid yet.',

  // Balance and payments in the workspace (LP-272).
  ws_topUp: 'Top up',
  ws_topUpTitle: 'Top up balance',
  ws_topUpText:
    'Any whole amount from ${{min}}. Credits do not expire while the account is active.',
  ws_topUpAmount: 'Amount, USD',
  ws_topUpAmountError: 'Enter a whole amount from ${{min}} to ${{max}}.',
  ws_topUpEmails: '≈ {{emails}} emails',
  ws_topUpPay: 'Pay ${{amount}}',
  ws_topUpPayTest: 'Pay ${{amount}} (test payment)',
  ws_topUpDone: '${{amount}} was added to your balance.',
  ws_topUpPending:
    'The payment is being confirmed. The balance updates in a minute.',
  ws_topUpError: 'The top-up failed. Please try again.',
  ws_balanceRunsOut: 'Runs out ~{{date}}',
  ws_balanceLowTitle: 'Balance is running low',
  ws_balanceLowText:
    '{{emails}} emails left, until about {{date}}. Top up to keep the outreach going.',
  ws_balanceLowTextNoDate:
    '{{emails}} emails left. Top up to keep the outreach going.',
  ws_balanceDepletedTitle: 'Balance is used up: search and sending are paused',
  ws_balanceDepletedText: 'Drafts and replies stay saved. Top up to continue.',
  ws_billingTitle: 'Balance and payments',
  ws_billingText:
    '${{price}} per email sent, any email: first, follow-up or reply. Lead search, research and drafts are included.',
  ws_topUpsTitle: 'Top-ups',
  ws_topUpsEmpty: 'No top-ups yet.',
  ws_topUpsLoadFailed: 'Couldn’t load payments.',
  ws_topUpStatus_pending: 'awaiting payment',
  ws_topUpStatus_completed: 'paid',
  ws_topUpStatus_canceled: 'canceled',
  ws_topUpStatus_failed: 'failed',
  ws_topUpTestBadge: 'test',
  ws_refunded: 'Refunded {{amount}}',
  ws_refundPending: 'Refund of {{amount}} in progress',
}
